import styled from "@emotion/styled";
import { Tab, TabProps, tabClasses, Tabs } from "@mui/material";
import React from "react";

interface BillingTabProps extends TabProps {
	to: string;
}

export const BillingTabs = styled(Tabs)`
	.MuiTabs-indicator {
		height: 4px;
		background-color: #0071e3;
	}
`;

export const BillingTab = styled((props: BillingTabProps) => <Tab {...props} />)`
	color: #bbb;
	font-size: 16px;
	line-height: 24px;
	padding: 6px 10px;

	&.${tabClasses.selected} {
		color: #0071e3;
	}
`;
